import * as consentLogAction from './consent-log-action'

export {
    consentLogAction,
}



// WEBPACK FOOTER //
// ./src/actions/consent-logs/index.js